import { ComponentRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CPGenericModalComponent } from '../cp-generic-modal/cp-generic-modal.component';

/**
 * Notes:
 *
 * `T`: the component you use when opening the modal
 *
 * `R`: type of the data that is expected to be returned after you click the confirmation button (save, continue ...)
 *
 * You get this through `afterClosed` subscription (i.e. `dialogRef.afterClosed().subscribe((data: R) => {  }))`
 */
export class CpDialogRef<T, R = any> {
  /** The instance of component opened into the dialog. */
  componentInstance: T;

  private readonly _afterClosed = new Subject<R>();
  private _dialogCloseCheck?: () => boolean;
  constructor() {}

  private setGenericConfirmEnabled(value: boolean) {
    const u = this.componentInstance as unknown;
    const dialog: ComponentRef<CPGenericModalComponent> = u as ComponentRef<CPGenericModalComponent>;
    if (dialog && dialog.instance && typeof dialog.instance.isConfirmEnabled === 'function') {
      dialog.instance.isConfirmEnabled(value);
    }
  }

  /**
   *
   * @param result
   */
  addDialogCloseValidator(fn: () => boolean) {
    this._dialogCloseCheck = fn;
    if (!this._dialogCloseCheck()) {
      this.setGenericConfirmEnabled(false);
    }
  }

  /**
   * `R`: type of the data that is expected to be returned after you click the confirmation button (save, continue ...)
   * @param result
   */
  close(result?: R) {
    if (this._dialogCloseCheck && result) {
      if (result.hasOwnProperty('trigger') && result['trigger'] === 'CONFIRM') {
        if (!this._dialogCloseCheck()) {
          this.setGenericConfirmEnabled(false);
          return;
        }
      }
    }
    this.setGenericConfirmEnabled(true);
    this._afterClosed.next(result);
  }

  afterClosed(): Observable<R> {
    return this._afterClosed.asObservable();
  }
}
